export default __webpack_public_path__ + "static/onboarding_background.f6b7f45c5f35442dff335e8855d326ab.jpg";